import { Card, CardBody, Col, Container, Row, Table, Badge } from "reactstrap";
import Breadcrumbs from "../../../../CommonElements/Breadcrumbs/Breadcrumbs";
import { useEffect, useState } from "react";
import apiRequestHelper from "../../../../utils/apiRequestHelper";
import { toast } from "react-toastify";
import { Btn } from "../../../../AbstractElements";
import { Link } from "react-router-dom";
import CenteredModal from "../../../Ui-Kits/Modal/CenteredModal/CenteredModal";

interface CTAType {
  id: number;
  imageUrl?: string;
  heading?: string;
  paragraph?: string;
  buttonText: string;
  buttonHref: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  _count?: {
    blogCTAs: number;
  };
}

const CTACardsContainer = () => {
  const [ctas, setCtas] = useState<CTAType[]>([]);
  const [selectedCtaId, setSelectedCtaId] = useState<number | null>(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCTAs();
  }, []);

  const fetchCTAs = async () => {
    try {
      setLoading(true);
      const response = await apiRequestHelper.get("/ctas");
      setCtas(response.data.data.ctas);
    } catch (error: any) {
      toast.error(
        error.response?.data?.messages?.[0]?.message || "Failed to load CTAs"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteSuccess = () => {
    setCtas((prev) => prev.filter((cta) => cta.id !== selectedCtaId));
  };

  const formatDate = (iso: string) => {
    if (!iso) return "-";
    const d = new Date(iso);
    return d.toLocaleDateString();
  };

  return (
    <>
      <Breadcrumbs mainTitle={"CTA Cards"} parent={"CTAs"} />

      <Container fluid>
        <Row className="mb-3">
          <Col>
            <Link to="/ctas/add">
              <Btn color="primary">Add New CTA</Btn>
            </Link>
          </Col>
        </Row>

        <Row>
          <Col xs="12">
            <Card>
              <CardBody>
                {loading ? (
                  <div className="text-center">
                    <p className="mb-0">Loading CTAs...</p>
                  </div>
                ) : ctas.length === 0 ? (
                  <div className="text-center">
                    <p className="mb-0">
                      No CTAs found. Create your first CTA!
                    </p>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <Table
                      bordered
                      hover
                      responsive
                      className="align-middle mb-0"
                    >
                      <thead>
                        <tr>
                          <th className="text-white" style={{ width: "60px" }}>#</th>
                          <th className="text-white" style={{ width: "90px" }}>Image</th>
                          <th className="text-white">Heading</th>
                          <th className="text-white">Paragraph</th>
                          <th className="text-white" style={{ width: "220px" }}>Button</th>
                          <th className="text-white" style={{ width: "140px" }}>Status</th>
                          <th className="text-white" style={{ width: "140px" }}>Blogs</th>
                          <th
                            style={{ width: "200px" }}
                            className="text-center text-white"
                          >
                            Actions
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {ctas.map((item, index) => (
                          <tr key={item.id}>
                            <td className="text-white">{index + 1}</td>

                            <td className="text-white">
                              {item.imageUrl ? (
                                <img
                                  src={item.imageUrl}
                                  alt="CTA"
                                  style={{
                                    width: 56,
                                    height: 40,
                                    objectFit: "cover",
                                    borderRadius: 6,
                                    display: "block",
                                  }}
                                />
                              ) : (
                                "N/A"
                              )}
                            </td>

                            <td style={{ minWidth: 220 }} className="text-white">
                              {item.heading ? item.heading : "N/A"}
                            </td>

                            <td style={{ maxWidth: 220 }} className="text-white">
                              {/* Inline paragraph rendering (you can edit your logic here) */}
                              {item.paragraph?.trim()
                                ? item.paragraph
                                  .trim()
                                  .split(/\s+/)
                                  .slice(0, 4)
                                  .join(" ") +
                                (item.paragraph.trim().split(/\s+/).length > 4
                                  ? "..."
                                  : "")
                                : "N/A"}
                            </td>

                            <td>
                              <Btn
                                color="info"
                                size="sm"
                                className="p-1"
                                style={{ pointerEvents: "none" }}
                              >
                                {item.buttonText}
                              </Btn>
                              <div className=" f-12 mt-1 text-white">
                                {item.buttonHref}
                              </div>
                            </td>

                            <td>
                              <Badge
                                color={item.isActive ? "success" : "warning"}
                              >
                                {item.isActive ? "Active" : "Inactive"}
                              </Badge>
                            </td>

                            <td>
                              <Badge color="primary">
                                {item._count?.blogCTAs || 0} Blog(s)
                              </Badge>
                            </td>

                            <td className="text-center">
                              <div className="d-flex justify-content-center gap-2">
                                <Link to={`/ctas/edit/${item.id}`}>
                                  <Btn className="btn-edit-custom">Edit</Btn>
                                </Link>

                                <Btn
                                  color="danger"
                                  onClick={() => {
                                    setSelectedCtaId(item.id);
                                    setModalOpen(true);
                                  }}
                                >
                                  Delete
                                </Btn>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      {selectedCtaId !== null && (
        <CenteredModal
          isOpen={modalOpen}
          toggle={() => setModalOpen(false)}
          blogId={selectedCtaId}
          url={"/ctas"}
          onDeleteSuccess={handleDeleteSuccess}
        />
      )}
    </>
  );
};

export default CTACardsContainer;
